var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'font-sans fixed w-full top-0 left-0 z-modal2 transform-gpu bg-none',
    'flex items-center justify-center overflow-hidden md:overflow-auto',
    'modal-bottom-tray',
    { 'modal-bottom-tray-animation': _vm.shouldFadeIn } ],on:{"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.cancel($event)},"touchstart":function($event){if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.cancel($event)}}},[_c('div',{ref:"modalContainer",class:[
      'mt-0',
      'min-h-auto h-auto',
      'overflow-auto flex flex-col bg-transparent',
      'oz-modal-container',
      'rounded-3xl',
      'full-size',
      // This horizontal margin will only come into effect on small devices.
      'mx-7',
      _vm.desktopModeWidthClass ]},[_c('div',{ref:"modalContainerInner",class:{
        'bg-white-100 dark:bg-nightfall-900': _vm.isDarkMode === 'auto',
        'bg-white-100': _vm.isDarkMode === false,
        'bg-nightfall-900': _vm.isDarkMode === true,
        'min-h-full': true,
        flex: true,
        'flex-grow': true,
        'flex-col': true,
        'overflow-hidden': true,
      }},[(_vm.$slots.header)?_c('header',{ref:"header",staticClass:"pt-4 pb-3 md:pb-4 px-4"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{ref:"modalBody",staticClass:"h-auto flex flex-grow flex-col p-0 overflow-auto"},[_vm._t("body")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }